__turbopack_context__.v({
  "banner": "_1Ir7TW_banner",
  "banner__button": "_1Ir7TW_banner__button",
  "banner__buttons": "_1Ir7TW_banner__buttons",
  "banner__message": "_1Ir7TW_banner__message",
});
